import * as THREE from "three";
import gsap from "gsap";

import { SCENE_STATES } from "../data/sceneStates.js";

const SHOTS = {
  [SCENE_STATES.INTRO]: {
    position: new THREE.Vector3(0.35, 0.65, 6.2),
    lookAt: new THREE.Vector3(0.2, 0.05, -0.7),
    fov: 40
  },
  [SCENE_STATES.ABOUT]: {
    position: new THREE.Vector3(-2.35, 0.95, 5.2),
    lookAt: new THREE.Vector3(-1.15, 0.15, -0.9),
    fov: 45
  },
  [SCENE_STATES.PROJECTS]: {
    position: new THREE.Vector3(2.1, 0.42, 5.1),
    lookAt: new THREE.Vector3(1.05, 0.05, -0.95),
    fov: 43
  },
  [SCENE_STATES.PROJECT_DETAIL]: {
    position: new THREE.Vector3(2.45, 0.3, 4.3),
    lookAt: new THREE.Vector3(1.65, 0.05, -0.9),
    fov: 35
  },
  [SCENE_STATES.SKILLS]: {
    position: new THREE.Vector3(-0.8, 1.45, 5.5),
    lookAt: new THREE.Vector3(-0.2, 0.45, -0.95),
    fov: 44
  },
  [SCENE_STATES.CONTACT]: {
    position: new THREE.Vector3(0.5, -0.08, 5.0),
    lookAt: new THREE.Vector3(0.6, -0.2, -1.3),
    fov: 45
  },
  [SCENE_STATES.LEGAL]: {
    position: new THREE.Vector3(-1.7, -0.2, 6.1),
    lookAt: new THREE.Vector3(-0.5, -0.35, -1.6),
    fov: 48
  }
};

export class CameraController {
  constructor({ profile }) {
    this.profile = profile;
    this.instance = new THREE.PerspectiveCamera(45, window.innerWidth / window.innerHeight, 0.1, 100);
    this.target = new THREE.Vector3(0, 0, 0);
    this.activeTimeline = null;

    this.applyShot(SCENE_STATES.INTRO, { immediate: true });
  }

  applyShot(state, { immediate = false } = {}) {
    const shot = SHOTS[state] ?? SHOTS[SCENE_STATES.INTRO];
    const duration = this.profile.prefersReducedMotion ? 0.01 : state === SCENE_STATES.PROJECT_DETAIL ? 1.05 : 0.9;

    if (this.activeTimeline) {
      this.activeTimeline.kill();
      this.activeTimeline = null;
    }

    if (immediate) {
      this.instance.position.copy(shot.position);
      this.instance.fov = shot.fov;
      this.target.copy(shot.lookAt);
      this.instance.updateProjectionMatrix();
      return Promise.resolve();
    }

    return new Promise((resolve) => {
      this.activeTimeline = gsap.timeline({
        defaults: { duration, ease: "power2.inOut" },
        onComplete: () => {
          this.activeTimeline = null;
          resolve();
        }
      });

      this.activeTimeline.to(this.instance.position, {
        x: shot.position.x,
        y: shot.position.y,
        z: shot.position.z
      }, 0);

      this.activeTimeline.to(this.target, {
        x: shot.lookAt.x,
        y: shot.lookAt.y,
        z: shot.lookAt.z
      }, 0);

      this.activeTimeline.to(this.instance, {
        fov: shot.fov,
        onUpdate: () => this.instance.updateProjectionMatrix()
      }, 0);
    });
  }

  resize(width, height) {
    this.instance.aspect = width / height;
    this.instance.updateProjectionMatrix();
  }

  update() {
    this.instance.lookAt(this.target);
  }
}
